import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { LayersTreeIcon } from "../LayersTreeIcon";
import { THREE_INDENTATION_WIDTH } from "../constants";

export interface LayersTreeBlockNameProps {
  depth: number;
  type: string;
}

export const LayersTreeBlockName = ({
  type,
  depth,
}: LayersTreeBlockNameProps) => (
  <div className="flex min-w-0 items-center gap-2 py-2">
    {Array.from({ length: depth }).map((_, depthIndex) => (
      <span
        aria-hidden="true"
        // eslint-disable-next-line react/no-array-index-key -- depthIndex is stable
        key={`depth-${depth}-level-${depthIndex}`}
        className={classNames(
          "absolute top-0 flex h-full opacity-0 transition-colors before:absolute before:left-0 before:top-0 before:flex before:h-full before:border-l before:content-[''] group-hover/tree:opacity-100",
        )}
        style={{ left: `-${depthIndex * THREE_INDENTATION_WIDTH}px` }}
      />
    ))}
    <LayersTreeIcon type={type} />
    <span className="truncate capitalize">
      {t(["builder_ui.block_type", type], {
        defaultValue: type,
      })}
    </span>
  </div>
);
